import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import SEO from '../components/SEO/SEO';
import HeaderComponent from '../components/Header';
import HeroPodcastDetail from '../components/Hero/HeroPodcastDetail';
import PodcastVideo from '../components/VideoComponent/PodcastVideo';
import PodcastDetails from '../components/PodcastDetail';
import SocialShare from '../molecules/SocialShare';
import Subscriptions from '../components/Subscriptions';
import PageLinks from '../components/PodcastDetail/components/PageLinks';
import SocialProof from '../components/SocialProof';
import FooterComponent from '../components/Footer';

import {
  Section,
  OuterWrapper,
  InnerWrapper,
  Audio,
} from '../styles/Templates/podcast-details';

const PodcastDetail = ({ data, pageContext, ...props }) => {
  const { t } = useTranslation();

  return (
    <Layout>
      <HeaderComponent theme="Fill - Light" component={data?.datoCmsHeader} />
      <HeroPodcastDetail component={data?.podcast} pathname={props?.pathname} />
      <Section>
        <OuterWrapper>
          <SocialShare heading="" orientation="vertical" />
          <InnerWrapper>
            <PodcastVideo
              component={data?.podcast?.podcastVideo[0].websiteVideo}
            />
            <Subscriptions heading={t('SUBSCRIBE TO US ON:')} />
            {data?.podcast?.audio && (
              <Audio
                dangerouslySetInnerHTML={{ __html: data?.podcast?.audio }}
              />
            )}
            <PodcastDetails podcast={data?.podcast} />
            <PageLinks
              component={{ next: pageContext?.next, prev: pageContext?.prev }}
            />
          </InnerWrapper>
        </OuterWrapper>
      </Section>
      <SocialProof component={data?.socialProof} />
      <FooterComponent component={data?.datoCmsFooterComponent} />
    </Layout>
  );
};

export default PodcastDetail;

export const Head = ({ data, location }) => {
  const { podcast } = data;
  return (
    <SEO
      title={podcast?.metaTags?.title}
      indexable={podcast?.indexable}
      description={podcast?.metaTags?.description}
      imgUrl={podcast?.metaTags?.image?.fluid?.src}
      pathname={location?.pathname}
    />
  );
};

export const getData = graphql`
  query fetchPodcast($id: String!, $language: String!) {
    datoCmsHeader(id: { eq: "DatoCmsHeader-REM2qHJMQSinBf2V1pBNOQ" }) {
      ...datoCmsHeader
    }
    datoCmsFooterComponent(id: { eq: "DatoCmsFooterComponent-120781524" }) {
      ...datoCmsFooterComponent
    }
    podcast: datoCmsPodcast(id: { eq: $id }) {
      ...datoCmsPodcast
    }
    socialProof: datoCmsSocialProofComponent(
      id: { eq: "DatoCmsSocialProofComponent-147084032" }
    ) {
      ...datoCmsSocialProofComponent
    }
    # Query all locales
    locales: allLocale(
      filter: { ns: { in: ["index"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
